const createChangeBackgroundCommand = ({ openChangeBackgroundDialogOpen }) => ({
	id: 'openChangeBackgroundDialog',
	run: (editor, sender, params) => {
		if (!openChangeBackgroundDialogOpen) {
			return;
		}

		const options = params;
		if (!options.sectionId) {
			const selected = sender.getSelected();
			if (selected?.ccid) {
				options.sectionId = `#${selected.ccid}`;
			}
		}

		window.gm_track(`openChangeBackgroundDialog`, { options });

		openChangeBackgroundDialogOpen(true, options);
	},
});

const createLayoutEditorCommand = ({ openLayoutDialog }) => ({
	id: 'openLayoutEditor',
	run: (editor, sender, params) => {
		openLayoutDialog && openLayoutDialog(true, params);
	},
});

const createOpenEditorDialogCommand = ({ openConfigurationDialog }) => ({
	id: 'openConfigurationEditor',
	run: (editor, options, params) => {
		openConfigurationDialog && openConfigurationDialog(true, params);
	},
});

const cloneLastChildItemOfSelector = (editor, selector, fromSection = '') => {
	const wrapper = editor.DomComponents.getWrapper().find(selector);
	if (wrapper.length > 0) {
		const parent = wrapper[0];
		let cloneElementSelector = '.column';
		if (window.currentTemplate === 'template7' && fromSection === 'section-accolades') {
			cloneElementSelector = '.columns';
		}
		const lastItem = parent.find(`${cloneElementSelector}:last-child`)[0];
		if (lastItem) {
			const newlyAdded = lastItem.clone();
			parent.components().add(newlyAdded);
			return newlyAdded;
		}
	}
	return null;
};

const createServiceItemCommand = () => ({
	id: 'createServiceItem',
	run: (editor) => {
		cloneLastChildItemOfSelector(editor, '#section-services .layoutable');
	},
});

const createAccoladeItemCommand = () => ({
	id: 'createAccoladeItem',
	run: (editor) => {
		cloneLastChildItemOfSelector(editor, '#section-accolades .layoutable', 'section-accolades');
	},
});

const createVideoItemCommand = () => ({
	id: 'createVideoItem',
	run: (editor) => {
		const newlyAdded = cloneLastChildItemOfSelector(editor, '#section-videos .layoutable');
		if (newlyAdded) {
			editor.runCommand('openConfigurationEditor', {
				sectionId: `#section-videos`,
				videoContainerId: `#${newlyAdded.getId()}`,
			});
		}
	},
});

const createWidgetItemCommand = () => ({
	id: 'createWidgetItem',
	run: (editor) => {
		const newlyAdded = cloneLastChildItemOfSelector(editor, '#section-calculator .layoutable');
		if (newlyAdded) {
			editor.runCommand('openConfigurationEditor', {
				sectionId: `#section-calculator`,
				widgetContainerId: `#${newlyAdded.getId()}`,
			});
		}
	},
});

export {
	createWidgetItemCommand,
	createChangeBackgroundCommand,
	createOpenEditorDialogCommand,
	createLayoutEditorCommand,
	createAccoladeItemCommand,
	createServiceItemCommand,
	createVideoItemCommand,
};
